import { render, staticRenderFns } from "./ReturnReasonSelect.vue?vue&type=template&id=58566781"
import script from "./ReturnReasonSelect.vue?vue&type=script&lang=js"
export * from "./ReturnReasonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports